import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";

export default function TermsClient() {
  const [content, setContent] = useState("");

  useEffect(() => {
    loadTerms();
  }, []);

  const loadTerms = async () => {
    try {
      const res = await axios.get(`${API}/admin/terms/active?type=client`);
      setContent(res.data?.content || "Termos não disponíveis.");
    } catch (e) {
      setContent("Erro ao carregar termos.");
    }
  };

  return (
    <div style={{ maxWidth: 800, margin: "40px auto", padding: 20 }}>
      <h1>Termos de Uso</h1>
      <div style={{ whiteSpace: "pre-wrap" }}>{content}</div>
    </div>
  );
}
